var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuisnessServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#F4F2FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 17.25H24.75V16.5C24.75 15.9033 24.5129 15.331 24.091 14.909C23.669 14.4871 23.0967 14.25 22.5 14.25H19.5C18.9033 14.25 18.331 14.4871 17.909 14.909C17.4871 15.331 17.25 15.9033 17.25 16.5V17.25H15.75C15.1533 17.25 14.581 17.4871 14.159 17.909C13.7371 18.331 13.5 18.9033 13.5 19.5V25.5C13.5 26.0967 13.7371 26.669 14.159 27.091C14.581 27.5129 15.1533 27.75 15.75 27.75H26.25C26.8467 27.75 27.419 27.5129 27.841 27.091C28.2629 26.669 28.5 26.0967 28.5 25.5V19.5C28.5 18.9033 28.2629 18.331 27.841 17.909C27.419 17.4871 26.8467 17.25 26.25 17.25ZM18.75 16.5C18.75 16.3011 18.829 16.1103 18.9697 15.9697C19.1103 15.829 19.3011 15.75 19.5 15.75H22.5C22.6989 15.75 22.8897 15.829 23.0303 15.9697C23.171 16.1103 23.25 16.3011 23.25 16.5V17.25H18.75V16.5Z",
    fill: "#7529D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuisnessServices);
export default __webpack_public_path__ + "static/media/buisness_services.6c490a64ee547d9b5ffd3e54864d74ba.svg";
export { ForwardRef as ReactComponent };